import React from 'react';
import { Button, Divider, IconButton } from '@mui/material';
import CloseIcon from '@mui/icons-material/Close';
import CalendarMonthIcon from '@mui/icons-material/CalendarMonth';
import AccessTimeIcon from '@mui/icons-material/AccessTime';
import editIcon from '../../assets/landingscreen/Group.svg'
import phone from '../../../src/assets/Schedule/phonecall.svg'
import certicate from '../../../src/assets/Schedule/certificate.svg';
import room from '../../../src/assets/Schedule/room.svg';
import provider from '../../../src/assets/Schedule/provider.svg';
import time from '../../../src/assets/Schedule/time.svg';
import dayjs from 'dayjs';
import { useSelector } from 'react-redux';
import { useNavigate } from 'react-router-dom';
export default function AptCard({ setIsAptcard,setScreen,selectedAppointment ,isfutureappointment }) {
  const homescreenprev = useSelector((state) => state.userPrivileges.homescreen);
const navigate=useNavigate()
  const percentage = 100; 
  const circleStyle = {
    background: `conic-gradient(#50869A ${percentage * 3.6}deg, #EDEDED ${percentage * 3.6}deg)`,
  };


  const angle = percentage * 3.6;
  const radians = (angle - 90) * (Math.PI / 180);
  const radius = 35;
  const smallCircleOffset = 8;

  const smallCircleStyle = {
    position: 'absolute',
    top: `${50 + radius * Math.sin(radians) - smallCircleOffset}px`,
    left: `${50 + radius * Math.cos(radians) - smallCircleOffset}px`,
    width: '22px',
    height: '22px',
    backgroundColor: '#FFFFFF',
    borderRadius: '50%',
    transform: 'translate(-50%, -50%)',
    boxShadow: "0px 4px 4px 0px rgba(0, 0, 0, 0.25)",
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
  };

  const formattedDate = new Date("").toLocaleDateString('en-US', {
    month: 'long',
    day: 'numeric',
    year: 'numeric',
  });


  return (
    <div
      className="fixed inset-0 flex items-center overflow-y-auto custom-scrollbar justify-center z-50"
      onClick={() => setIsAptcard(false)}
      
      // Close the popup when the overlay is clicked fixed inset-0 z-50 flex items-center justify-center overflow-y-auto bg-black bg-opacity-50
    >
      {/* Overlay */}
      <div className="absolute inset-0  bg-black opacity-50"></div>

      <div
        className="relative z-10 w-full sm:min-w-[40%] sm:w-auto  h-auto  px-4 py-2 rounded-md bg-white shadow-custom flex flex-col items-start"
        onClick={(e) => e.stopPropagation()} // Prevent closing when clicking inside the popup
      >
          <div className="p-2 pb-4 w-full flex justify-between items-start border-b-2">
          
          <div>

          <div className="flex w-full flex-wrap  ">
            <div className="relative mt-2 items-center flex justify-center w-[65px] h-[65px] ">
              <div
                className="relative flex justify-center items-center w-[65px] h-[65px] rounded-full"
                style={circleStyle}
              >
                <div className="flex justify-center items-center w-[55px] h-[55px] bg-[#FAFAF9] rounded-full">
                  <div className="flex justify-center items-center w-[48px] h-[48px] bg-[#C4C4C4] rounded-full">
                    <img  onClick={() => {
  navigate('/landing', {
    state: { fromPatientId: selectedAppointment.patientid }
  });
}} className="flex justify-center items-center w-[48px] h-[48px] bg-[#C4C4C4] rounded-full cursor-pointer"
                     onError={(e) => e.target.src = 'data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAOEAAADhCAMAAAAJbSJIAAAAM1BMVEXk5ueutLeqsbTn6eqpr7PJzc/j5ebf4eLZ3N2wtrnBxsjN0NLGysy6v8HT1tissra8wMNxTKO9AAAFDklEQVR4nO2d3XqDIAxAlfivoO//tEOZWzvbVTEpic252W3PF0gAIcsyRVEURVEURVEURVEURVEURVEURVEURVEURVEURflgAFL/AirAqzXO9R7XNBVcy9TbuMHmxjN6lr92cNVVLKEurVfK/zCORVvW8iUBnC02dj+Wpu0z0Y6QlaN5phcwZqjkOkK5HZyPAjkIjSO4fIdfcOwFKkJlX4zPu7Ha1tIcwR3wWxyFhRG6g4Je0YpSPDJCV8a2Sv2zd1O1x/2WMDZCwljH+clRrHfWCLGK8REMiql//2si5+DKWKcWeAGcFMzzNrXC/0TUwQ2s6+LhlcwjTMlYsUIQzPOCb7YBiyHopyLXIEKPEkI/TgeuiidK/R9FniUDOjRDpvm0RhqjMyyXNjDhCfIMYl1gGjIMIuYsnGEYRMRZOMMunaLVwpWRW008v6fYKDIzxCwVAeNSO90BJW6emelYBRF/kHpYGVaoxTDAaxOFsfP9y8hpJ4xd7gOcij7JNGQ1EYFgkPJa1jQEiYZXRaRINKxSDUW9n+FT82lSKadkiru9/4XPqSLWOekGPoY05TAvLm9orm+YWuwHoBHkZKijNBJGmeb61eL6Ff/6q7bLr7yvv3vKGhpDRjvgjGaPz+gUg6YgcvpyAR2FIZ9U6nEEyZRTovmEU32KichpGn7C17XrfyH9gK/c0CMP05HZIM2uf9sEveizKveBy9/6Qt7o89ne33D525cfcIMW6ab+TMEukQbQbu+xu7X3A9bChmWaCeAkG17bpntwXgWxHaMzGPmUaR5dQZiKqRVeUZ3047fi3nAu28h4CHxCsZAgmEH8Y27jJAhm8c+5RQzRQNVGhVFSfxOYIjp/pP7RxzjevYXVGf4eLt+BJ1vCuLuLkrgABgCGXZ2wik5uty+oBvNirI6mkzhAf4Gsb58Hcm67Jzd+KwD10BYPLL3e0MjvKrgAULnOfveF/O4N2Xb9BZom3gJes3F9X5Zze8/6Yt09b4CrqsEjUv8oFBaR2rl+6CZr2xVrp24o/WitBKuGrrpl1+bFkmK2qXTON4VpbdfLa7o7y/WdLxG7lm2Lqh2clOwTegbvc/vj2U78CwhA87Bn8G5Nk3eOb0Nsr9flz3sG78UUtue4kpv1xvjg3TMay62BMlTlP+vrOMnJsRmt/ze0jsfkPPYdAH57hK+34PeOyc8XIXu5xT2HsUkdZz+adwg8HGFfQ3K5jtDvbUiO4Di9/ywHGrL88pDizZ++oTp+an+SMX/ndymUCwmHMdO7yuOx83pUx/eEMU0AvxWndwgidAqOZ8ypCwdEfvvEo6D9HwpA8wzvmOJEqAg9ySu8g4x0Hb9hSB/BANEKJ+LbPBU0lzbAJs4xt1AoshKkUGQmiH8/jJ0gdhTTLmSegHlPE0oOdXALnqDjKYh3px//fSgSWG8UqfrrIICzYYSJXRr9BSPbpNzw7gBjKjKOYI7ReIGqQRIap5+5MdjyvuDkExvGeXSlONWZAP3/AZBwJohU7QJRGU+cTVH18ELmRPNBmibW6MT/k1b0XhdkRBvyT6SB6EYv/GvhSmRNpGngRULsAlxMCGNXp7w3FfdEbTEEDdLI9TdIKRUzUesa3I461ER8cpNT7gMRhpKmYVS9ELOgCUQsa4SsulciKiLbY+AnHD8cpuhISsnxpamI84sbDq9qYJgf8wiiOBrC7Ml7M7ZECCqKoiiKoiiKoiiKoijv5AvJxlZRyNWWLwAAAABJRU5ErkJggg=='}
                     src={`/cloud-assets/chim/public/assets/images/profilepictures/${selectedAppointment.patientid}.png`} alt='%/'/>
                  </div>
                </div>
            
              </div>
            </div>
        
          
      
            <div className='flex gap-2 flex-col  ml-4  w-auto'>
              <div className='flex items-center gap-2 '>
              <div  onClick={() => {
  navigate('/landing', {
    state: { fromPatientId: selectedAppointment.patientid }
  });
}} className=" text-center [font-family:'Inter-Medium',Helvetica] cursor-pointer font-bold text-[#202020] text-lg">
              {selectedAppointment.firstname} {selectedAppointment.lastname}
            </div>
            <div className=" text-center bg-[#E17954] font-semibold text-[#ffffff] rounded-full px-2 py-1  text-xs ">
            #{selectedAppointment.patientid}
            </div>
              </div>
         <div className='flex gap-2 w-full'>
          
         <div className=" relative text-[12px] items-center leading-6 font-inter text-[#71717A] text-left inline-block">
            <CalendarMonthIcon  className='w-4 h-4' sx={{color:'#E17954',width:"16px"}}/>   {selectedAppointment.dob}
           </div>
           <div className=" relative text-[12px] flex gap-1 items-center leading-6 font-inter text-[#71717A] text-left inline-block">
            <img src={phone} alt='$/'  className='w-4 h-4' sx={{color:'#E17954'}}/> 
            <div>{selectedAppointment.phone}</div>
           </div>
         </div>
         <div className=" relative text-[12px] flex gap-1 items-center leading-6 font-inter text-[#71717A] text-left inline-block">
            <img src={certicate} alt='$/'  className='w-4 h-4' sx={{color:'#E17954'}}/> 
            <div>  {selectedAppointment.insurancename}</div>
           </div>
             
        
          </div>
         
          <div className="flex   items-start gap-2 w-[100%]  justify-between mt-6">
                  <div className="flex gap-2 flex-col ">
             <div className='text-sm w-[150px] font-inter text-[#71717A] text-left'>APPOINTMENT TIME</div>
                <div className="h-4 text-left text-[24px] font-bold text-[#E17954]   text-sm tracking-[0] leading-4 whitespace-nowrap">
                {dayjs(`2000-01-01 ${selectedAppointment.starttime}`).format('h:mm A')}
                </div>
                 <div className="h-4 text-left text-black font-semibold text-[#b1b1b1] text-sm tracking-[0] leading-4 whitespace-nowrap">
                 {dayjs(selectedAppointment.startdate).format('D MMMM YYYY')}
                 </div>
              
            </div>
            <div className="flex w-full gap-2 items-center">
    
    
            </div>
            <div className='mb-1'>
                <div className='w-[200px] cursor-pointer bg-[#E179541A] font-semibold border-[1.5px] border-gray-200 text-[#E17954] px-2 py-1 rounded-full'
                 onClick={()=>{
                       if(homescreenprev.includes("Visit Confirmation")){
                  setScreen(2)
                       }
                 }
                 }
                variant="outlined" color="error">
                {selectedAppointment.visit_confirmation || 'Status '}
                </div>    
            </div>

          </div>
        
        </div>
           </div>


          <IconButton
            edge="end"
            aria-label="close"
            onClick={() => setIsAptcard(false)}
            style={{color:'#C7C7CB'}}
          >
            <CloseIcon />
          </IconButton>
        </div>        
     
        <div className='flex flex-col w-full gap-4 mt-4'>
     


       <div className="flex w-full flex-row gap-4 items-start justify-between ">
  {/* First Column */}
  <div className="flex flex-col">
    <div   onClick={()=>{
      if(homescreenprev.includes('Room Assignment')){
        setScreen(6)
      }
      
      
      }} className="flex gap-2 items-center group">
      <div className='px-2 py-2 rounded bg-[#E179541A] hover:bg-[#E17954]'>
      <img   className="group-hover:filter group-hover:brightness-0 group-hover:invert group-hover:contrast-100"
 src={room} alt="/Edit" style={{ width: '15px', cursor: 'pointer' }} />

      </div>

      <div className="[font-family:'Lexend-Light',Helvetica] text-start font-light text-[#a1a0a7] text-sm tracking-[0] leading-[22px]">
        Room
      </div>
    </div>
    <div className="w-full relative text-[14px] leading-6 font-poppins font-bold text-[#16151c] text-left inline-block font-lexend">
    {selectedAppointment?.room_no || "OP"}

    </div>
  </div>

  {/* Second Column */}
  <div className="flex flex-col">
  <div 
    onClick={() => setScreen(5)} 
    className="flex gap-2 items-center group" // Added 'group' here
  >
    <div className="px-2 py-2 rounded bg-[#E179541A] hover:bg-[#E17954]">
      <img 
        className="group-hover:filter group-hover:brightness-0 group-hover:invert group-hover:contrast-100" // Added 'group-hover' here
        src={provider} 
        alt="/Edit" 
        style={{ width: '15px', cursor: 'pointer' }} 
      />
    </div>

    <div className="[font-family:'Lexend-Light',Helvetica] text-start font-light text-[#a1a0a7] text-sm tracking-[0] leading-[22px]">
      Provider
    </div>
  </div>
  <div className="w-full relative text-[14px] leading-6 font-poppins font-bold text-[#16151c] text-left inline-block font-lexend">
    {selectedAppointment.providername}
  </div>
</div>


  {/* Third Column */}
  <div onClick={()=>setScreen(7)} className="flex flex-col">
    <div className="flex gap-2 items-center group">
    <div className='px-2 py-2 rounded bg-[#E179541A] hover:bg-[#E17954]'>
    <img 
  src={time} 
 className="group-hover:filter group-hover:brightness-0 group-hover:invert group-hover:contrast-100"
  alt="/Edit" 
  style={{ width: '15px', cursor: 'pointer' }} 
/>

      </div>

      <div className="[font-family:'Lexend-Light',Helvetica] text-start font-light text-[#a1a0a7] text-sm tracking-[0] leading-[22px]">
     Type
      </div>
    </div>
    <div className="w-full relative text-[14px] leading-6 font-poppins  font-bold text-[#16151c] text-left inline-block font-lexend">
      {selectedAppointment.type}
    </div>
  </div>
       </div>

{/* lets */}
        </div>

        
        <div className='flex  mb-4  mt-8 w-full justify-start'>
        <div      
  onClick={()=>setScreen(1)}
      className={`cursor-pointer py-2  font-inter  text-xs md:text-[11px] tracking-tight text-center rounded shadow-md flex items-center justify-center transition-colors duration-300 ease-in-out 
    bg-[#000000] text-[#ffffff]  px-6  whitespace-nowrap`}
    >
 {!isfutureappointment?"Open Appointment":"Reschedule"}
    </div>
        {!isfutureappointment &&<div    
        onClick={()=>setScreen(3)}  
      className={` cursor-pointer mx-3 font-inter font-semibold  text-xs md:text-[11px] tracking-tight text-center rounded shadow-md flex items-center justify-center transition-colors duration-300 ease-in-out 
    border-[1.5px] border-[black] text-black px-6 md:px-10 h-[28px] md:h-[32px] whitespace-nowrap`}
    >
  Take Payment
    </div>}
          </div>
      </div>
      
     
    </div>
  );
}
